module.exports = __webpack_public_path__ + "img/icon-12.f963ca72.png";